<script>import { goto } from "$app/navigation";
import { Card } from "@infinitro/card";
import { toGameSlug, toProviderSlug } from "@infinitro/catalog-min";
import { cfgBaseCurrency } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import {
  closeThisModal,
  displayInFiat,
  formatNumber,
  isMobile,
  loggedIn,
  ModalDialog,
  providerBasePath,
  selectedBetSlip,
  selectedProfile,
  stateOpenModal,
  toSiteUrl
} from "@infinitro/global";
import { CurrencyIcon } from "@infinitro/icons";
import { Modal } from "@infinitro/modal";
import { Text } from "@infinitro/text";
import { get } from "svelte/store";
const theseModals = [ModalDialog.BetSlip];
let bet = null;
let profit = 0;
const closeModal = () => theseModals.forEach(closeThisModal);
const playNow = () => {
  if (!bet) {
    return;
  }
  const url = toSiteUrl(
    `${providerBasePath(bet.providerName)}${toProviderSlug(bet.providerName)}/${toGameSlug(bet.gameName)}`,
    get(loggedIn)
  );
  closeModal();
  goto(url);
};
const openUserInfoModal = (username) => {
  if (username === void 0 || username === "" || !$loggedIn) {
    return;
  }
  selectedProfile.set(username);
  stateOpenModal.set(ModalDialog.OtherProfile);
};
selectedBetSlip.subscribe((betData) => {
  if (betData) {
    bet = betData;
    const payout = $displayInFiat ? bet.paidTotalUsd : bet.paidTotal;
    const wager = $displayInFiat ? bet.wagerTotalUsd : bet.wagerTotal;
    profit = parseFloat(payout) - parseFloat(wager);
  }
});
</script>

{#if $stateOpenModal && theseModals.includes($stateOpenModal) && bet}
	<Modal
		title={$isMobile ? 'Bet Slip' : ''}
		{closeModal}
		width={$isMobile ? 'auto' : '531px'}
		maxWidth="95vw"
		maxHeight="98vh"
		height="562px"
		padding={$isMobile ? '24px' : '32px'}
		showCloseButton={true}
		zIndexOverlay={11}
		zIndexUnderlay={10}
	>
		<div class="bet-slip-content">
			{#if !$isMobile}
				<h2 class="modal-title">Bet Slip</h2>
			{/if}

			<!-- Profit Section -->
			<div class="profit-section">
				<Text type="body" bodyWeight="regular" textColor="white">
					{$t(Verbiage.profit)}
				</Text>
				<div class="profit-amount">
					<CurrencyIcon currency={bet.currency} size="32" />
					<span class="profit-amount-text">
						{formatNumber(profit, $displayInFiat, true)}
						{$displayInFiat ? cfgBaseCurrency() : bet.currency.toUpperCase()}
					</span>
				</div>
				<Text type="body" bodyWeight="regular" textColor="white">
					{formatNumber(
						$displayInFiat ? bet.paidTotal - bet.wagerTotal : bet.paidTotalUsd - bet.wagerTotalUsd,
						!$displayInFiat,
						true
					)}
				</Text>
			</div>

			<!-- Bet Amount and Payout Section -->
			<div class="bet-details">
				<div class="details-row">
					<div class="detail-column">
						<Text type="body" bodyWeight="regular" textColor="gray">
							{$t(Verbiage.bet)}
							{$t(Verbiage.amount)}
						</Text>
						<Text type="body" bodyWeight="semibold" customStyle="font-size: 18px;">
							{formatNumber(
								$displayInFiat ? bet.wagerTotal : bet.wagerTotalUsd,
								!$displayInFiat,
								true
							)}
						</Text>
					</div>
					<div class="detail-column detail-column-right">
						<Text type="body" bodyWeight="regular" textColor="gray">
							{$t(Verbiage.payout)}
						</Text>
						<Text type="body" bodyWeight="semibold" customStyle="font-size: 18px;">
							{formatNumber(bet.multiplier, false, true)}x
						</Text>
					</div>
				</div>
			</div>

			<!-- Separator Line -->
			<div class="separator"></div>

			<!-- User Section -->
			<button class="user-section" on:click={() => openUserInfoModal(bet.username)}>
				<Text type="body" bodyWeight="semibold">
					{bet.username || $t(Verbiage.hidden)}
				</Text>
				<Text type="body" bodySize="small" textColor="gray">
					{$t(Verbiage.on)}
					{new Date(bet.createdAt).toLocaleDateString()}, {new Date(
						bet.createdAt
					).toLocaleTimeString()}
				</Text>
			</button>

			<!-- Game Tile Section -->
			<button type="button" class="game-tile" on:click={playNow}>
				<div class="game-image">
					<Card
						width="80"
						item={{
							game: bet.gameName.toLowerCase(),
							prov: bet.providerSlug.toLowerCase(),
							tile: `t/${toProviderSlug(bet.providerName)}/${toGameSlug(bet.gameName)}`,
							alt: `${bet.gameName} by ${bet.providerName}`
						}}
						thumbnail={true}
						showOverlay={false}
						thumbnailBig={true}
					/>
				</div>
				<div class="game-info">
					<Text type="body" bodyWeight="semibold">
						{bet.gameName}
					</Text>
					<Text type="body" bodySize="small" textColor="gray">
						{bet.providerName}
					</Text>
				</div>
				<div class="play-now">
					<Text type="body" bodyWeight="semibold" textColor="gray">
						{$t(Verbiage.play_now)} &gt;
					</Text>
				</div>
			</button>
		</div>
	</Modal>
{/if}

<style>
	.bet-slip-content {
		display: flex;
		flex-direction: column;
		gap: 1.5rem
}

	.modal-title {
		margin-bottom: 0.5rem;
		text-align: center;
		font-size: 1.5rem;
		line-height: 2rem;
		font-weight: 600;
		color: var(--text-primary)
}

	.profit-section {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.5rem;
		padding-top: 1rem;
		padding-bottom: 1rem
}

	.profit-amount {
		display: flex;
		align-items: center;
		gap: 0.5rem
}

	.profit-amount-text {
		font-size: 32px;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity));
		font-family: var(--font-main);
		line-height: 1.2;
		padding: 2px 0
}

	.bet-details {
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
		border-radius: 0.75rem;
		padding: 1rem;
		background: linear-gradient(180deg, #222c55 0%, #1b254c 100%)
}

	.details-row {
		display: flex;
		gap: 1rem
}

	.detail-column {
		display: flex;
		flex: 1 1 0%;
		flex-direction: column;
		gap: 0.5rem
}

	.detail-column-right {
		align-items: flex-end;
		text-align: right
}

	.separator {
		height: 1px;
		width: 100%;
		background: var(--border-color, rgba(255, 255, 255, 0.1))
}

	.user-section {
		display: flex;
		cursor: pointer;
		align-items: center;
		gap: 0.5rem;
		transition-property: all;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
		border: none;
		width: 100%;
		text-align: left;
		background: transparent;
		padding: 0
}

	.user-section:hover {
		opacity: 0.8
}

	.user-avatar {
		flex-shrink: 0
}

	.game-tile {
		display: flex;
		width: 100%;
		cursor: pointer;
		align-items: center;
		gap: 0.75rem;
		border-radius: 0.75rem;
		padding: 0.5rem;
		text-align: left;
		transition-property: all;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 150ms;
		border: none;
		font: inherit;
		color: inherit;
		background: linear-gradient(180deg, #222c55 0%, #1b254c 100%)
}

	.game-tile:hover {
		opacity: 0.9;
		transform: translateY(-2px)
}

	.game-image {
		flex-shrink: 0
}

	.game-info {
		display: flex;
		flex: 1 1 0%;
		flex-direction: column;
		gap: 0.25rem
}

	.play-now {
		display: flex;
		flex-shrink: 0;
		align-items: center
}
</style>
